"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query getPlannerProgressService($plannerType: String, $lotNumber: String) {
        planner {
            activeDate
            plannerId
            plannerSections {
                nodes {
                    name
                    plannerSectionId
                    sectionContents {
                        nodes {
                            content {
                                contentType
                                tag
                            }
                            contentId
                        }
                    }
                }
            }
            version
        }
        UserProfile {
            plannerProgress(plannerType: $plannerType, lotNumber: $lotNumber) {
                nodes {
                    section
                    completed
                    total
                    percentCompleted
                }
            }
        }
        userPlanners(
            condition: { lotNumber: $lotNumber, plannerType: $plannerType }
        ) {
            nodes {
                plannerType
                lotNumber
                completedContents {
                    nodes {
                        content {
                            contentId
                            contentType
                            tag
                            sectionContents {
                                nodes {
                                    plannerSection {
                                        name
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;exports.getPlannerProgress=e;
//# sourceMappingURL=queries.js.map
